import axios from 'axios'
import router from '@/router'

// 创建 axios 实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API || 'http://localhost:8000',
  timeout: 5000, // 请求超时时间
  headers: {
    'Content-Type': 'application/json'
  }
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }
    return config
  },
  error => {
    console.error('请求错误:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    if (res.status === 200) {
      return res
    }
    return Promise.reject(new Error(res.message || res.msg || '未知错误'))
  },
  error => {
    console.error('响应错误:', error)
    
    // 处理401未授权的情况
    if (error.response && error.response.status === 401) {
      console.warn('用户未登录或token已过期')
      // 清除本地存储的token
      localStorage.removeItem('token')
      // 重定向到登录页
      router.push('/login')
      return Promise.reject(new Error('请重新登录'))
    }
    
    return Promise.reject(error)
  }
)

/**
 * get请求
 * @param {string} url - 请求地址
 * @param {object} params - 请求参数
 * @param {object} config - 额外配置
 * @returns {Promise}
 */
export function get(url, params = {}, config = {}) {
  return service.request({
    method: 'get',
    url,
    params,
    ...config
  })
}

/**
 * post请求
 * @param {string} url - 请求地址
 * @param {object} data - 请求数据
 * @param {object} config - 额外配置
 * @returns {Promise}
 */
export function post(url, data = {}, config = {}) {
  return service.request({
    method: 'post',
    url,
    data,
    ...config
  })
}

export default {
  get,
  post
} 
